function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import fr from "./filter.js";
import { isArray as z } from "../../util/code-utils.js";

var is = /*#__PURE__*/function () {
  function is(t) {
    _classCallCheck(this, is);

    this.filters = t, this.filters = t;
  }

  _createClass(is, [{
    key: "zc",
    value: function zc(t) {
      var r = !0;

      for (var e = 0; e < this.filters.length; e++) {
        var o = this.filters[e];
        var s = !1;

        for (var _r = 0; _r < o.length; _r++) {
          if (o[_r].zc(t)) {
            s = !0;
            break;
          }
        }

        if (!s) {
          r = !1;
          break;
        }
      }

      return r;
    }
  }, {
    key: "bt",
    value: function bt() {
      var t = [];

      for (var r = 0; r < this.filters.length; r++) {
        var e = this.filters[r],
            o = [];

        for (var _t = 0; _t < e.length; _t++) {
          o.push(e[_t].bt());
        }

        t.push(o);
      }

      return t;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      if (null == t || !z(t)) return null;
      var r = [];

      for (var e = 0; e < t.length; e++) {
        var o = [],
            s = t[e];

        for (var _t2 = 0; _t2 < s.length; _t2++) {
          o.push(fr.fromJson(s[_t2]));
        }

        r.push(o);
      }

      return new is(r);
    }
  }, {
    key: "Rn",
    value: function Rn(t) {
      var r = [];

      for (var e = 0; e < t.length; e++) {
        var o = [],
            s = t[e];

        for (var _t3 = 0; _t3 < s.length; _t3++) {
          o.push(fr.Rn(s[_t3]));
        }

        r.push(o);
      }

      return new is(r);
    }
  }]);

  return is;
}();

export { is as default };